module.exports = __webpack_public_path__ + "static/media/centerTwo.b67aa849.png";